import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCommentsCount } from "../../../../state/selectors/Publications.selectors";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";

function CommunityContributionsGeneCard({ card, commentCount }) {
  return (
    <CardWrapper {...card}>
      {commentCount ? (
        <span className="tw-font-bold">
          <span data-testid="comments">
            <span className="tw-font-normal tw-pr-1">Comments:</span>
            {commentCount}
          </span>
        </span>
      ) : null}
    </CardWrapper>
  );
}

CommunityContributionsGeneCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  commentCount: PropTypes.number,
};

CommunityContributionsGeneCard.defaultProps = {
  commentCount: 0,
};

const mapStateToProps = (state) => ({
  commentCount: getCommentsCount(state),
});

export default connect(mapStateToProps)(CommunityContributionsGeneCard);
